import React from "react";
import "./card-rates-description-home.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { navigate } from "gatsby";
interface CardInterfaceDescription {
  datas: any;
}
const icon_right = require("../../../assets/images/icons/Icon-right.svg");
const CardRatesDescriptionHome = (props: CardInterfaceDescription) => {
  const value = props.datas;
  return (
    <div>
      <div>
        <div className="a-share-modal-home__container__cardbody__internal">
          <div className="a-share-modal-home__container__cardbody__internal__image">
            <img
              src={value.imagenPrincipal[0].file.url}
              alt={value.imagenPrincipal[0].title}
            />
          </div>
          <div className="a-share-modal-home__container__cardbody__internal__text">
            <h4>{value.tituloBanner}</h4>
            <p>
              {value.descripcion &&
                JSON.parse(value?.descripcion?.raw)?.content[0]?.content[0]
                  ?.value}
            </p>
          </div>
          <div
            className={`a-share-modal-home__container__cardbody__internal__button gtmRedDeAmorSesionIniciadaContenidoServiciosConocerMas${normalizeTwoWords(
              value.tituloBanner
            )}`}
            onClick={() => {
              /*window.location.assign(
                `${window.location.origin}${value.redireccionBoton}`
              );*/
              navigate(value.redireccionBoton);
            }}
          >
            <div
              className={`ver-mas-home gtmRedDeAmorSesionIniciadaContenidoServiciosConocerMas${normalizeTwoWords(
                value.tituloBanner
              )}`}
            >
              <p
                className={`gtmRedDeAmorSesionIniciadaContenidoServiciosConocerMas${normalizeTwoWords(
                  value.tituloBanner
                )}`}
              >
                {value.tituloBoton}
              </p>
              <div
                className={`ver-mas-imagen-home  gtmRedDeAmorSesionIniciadaContenidoServiciosConocerMas${normalizeTwoWords(
                  value.tituloBanner
                )}`}
              >
                <img
                  src={icon_right}
                  alt={"ver-mas icon"}
                  className={`gtmRedDeAmorSesionIniciadaContenidoServiciosConocerMas${normalizeTwoWords(
                    value.tituloBanner
                  )}`}
                />
              </div>
            </div>
          </div>
          {value.tipoTitulo ? (
            <div className="a-share-modal-home__container__cardbody__internal__static">
              <div className="a-share-modal-home__container__cardbody__internal__free">
                <p>{value.tipoTitulo}</p>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
export default CardRatesDescriptionHome;
